export default "__VITE_ASSET__h4ulyiL6__"